export enum NotificationTypes {
  Export = "EXPORT",
  Import = "IMPORT",
  Report = "REPORT",
  PermissionChange = "PERMISSIONCHANGE",
  Custom = "CUSTOM",
}
